import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import * as fromServices from '../../services';

@Component({
  selector: 'hdw-filter-by',
  templateUrl: './filter-by.component.html',
  styleUrls: ['./filter-by.component.scss']
})
export class FilterByComponent implements OnInit {
  private checkboxData: any;
  private filterByChange = new Subject<string>();
  public isOrganTransplantType: boolean;
  public organTransplantFormGroup: FormGroup;
  public filterByName: string;
  public canShowOrganSelection: boolean = false;
  public organTypes: { value: string; id: string; name: string }[] = fromServices.OrganTransplantTypes;
  @Output() filterByEmitter: EventEmitter<{
    filterBy: string;
    checkboxData?: { name: string; value: boolean }[];
  }>;

  constructor(private toolIdentifierService: fromServices.ToolIdentifierService, private fb: FormBuilder) {
    this.filterByEmitter = new EventEmitter<{
      filterBy: string;
      checkboxData?: { name: string; value: boolean }[];
    }>();
    this.filterByChange = new Subject<string>();
  }

  public ngOnInit(): void {
    this.initToolType();
    this.initFilterBy();
    if (this.isOrganTransplantType) {
      this.initFormGroup();
    }
  }

  private initToolType(): void {
    this.isOrganTransplantType =
      this.toolIdentifierService.getCurrentTool() === fromServices.LocatorTools.OrganTransplantCenter;
  }

  private initFormGroup(): void {
    this.organTransplantFormGroup = this.fb.group({
      all: new FormControl(false),
      heart: new FormControl(false),
      intestine: new FormControl(false),
      kidney: new FormControl(false),
      liver: new FormControl(false),
      lung: new FormControl(false),
      pancreas: new FormControl(false),
      pancreasIslet: new FormControl(false),
      vascularized: new FormControl(false)
    });
  }

  private initFilterBy(): void {
    this.filterByChange.pipe(debounceTime(500)).subscribe(value => {
      this.filterByName = value;
      const emittedValue = { filterBy: this.filterByName, checkboxData: null };
      if (this.isOrganTransplantType) {
        emittedValue.checkboxData = this.checkboxData;
      }
      this.filterByEmitter.emit(emittedValue);
    });
  }

  public handleFilterBy(filterBy: string): void {
    this.filterByChange.next(filterBy);
  }

  public handleOrganSelection(): void {
    this.canShowOrganSelection = !this.canShowOrganSelection;
  }

  public handleCheckboxClick(id: string): void {
    if (id === 'all') {
      const value = this.organTransplantFormGroup.controls['all'].value;
      Object.keys(this.organTransplantFormGroup.controls).forEach(controlName => {
        this.organTransplantFormGroup.get(controlName)?.setValue(value);
      });
    }
    this.buildCheckboxData();
  }

  private buildCheckboxData(): void {
    this.checkboxData = {};
    Object.keys(this.organTransplantFormGroup.controls).forEach(controlName => {
      this.checkboxData[controlName] = this.organTransplantFormGroup.get(controlName).value;
    });
    const emittedValue = {
      filterBy: this.filterByName,
      checkboxData: this.checkboxData
    };
    this.filterByEmitter.emit(emittedValue);
  }
}
